<!-- expandable-button.component.html -->
<div class="expandable-wrapper">
  <button class="expand-btn border-radius-xxx-large border-all" [class.expanded]="isExpanded" (click)="toggleExpand()">
    <img src="{{ image() }}" alt="Icon" />
    <span class="expand-text fw-bold">{{ title() }}</span>
  </button>
</div>
